import axios from "axios";

const normalizeApiBaseUrl = (url) => {
  return url?.replace(/\/api\/?$/, "");
};

const baseURL =
  process.env.NODE_ENV === "development"
    ? `http://${window.location.hostname}:8080`
    : normalizeApiBaseUrl(process.env.REACT_APP_BASE_URL);

export const api = axios.create({
  baseURL: baseURL,
});

api.interceptors.request.use((config) => {
  if (typeof config.url === "string") {
    const isAbsoluteUrl = /^[a-z][a-z\d+\-.]*:\/\//i.test(config.url) || config.url.startsWith("//");

    if (!isAbsoluteUrl) {
      const normalizedUrl = config.url.startsWith("/") ? config.url : `/${config.url}`;
      config.url = normalizedUrl === "/api" || normalizedUrl.startsWith("/api/")
        ? normalizedUrl
        : `/api${normalizedUrl}`;
    }
  }

  return config;
});

export * from "./accounts/accountsApi";
export * from "./notifications/notificationsApi";
export * from "./admin/adminEmailsApi";
export * from "./admin/adminUsersApi";
export * from "./admin/adminIntegratorUsersApi";
export * from "./baseData/baseDataApi";
export * from "./clients/clientsApi";
export * from "./comissions/comissionRulesApi";
export * from "./comissions/comissionsApi";
export * from "./comissions/comissionVariablesApi";
export * from "./home/homeApi";
export * from "./manage/manageApi";
export * from "./meeting/meetingApi";
export * from "./powerDistributionCompany/pdcApi";
export * from "./powerDistributionCompany/pdcKnowledgeApi";
export * from "./projects/projectsApi";
export * from "./stages/stagesApi";
export * from "./userProvidences/userProvidencesApi";
export * from "./users/usersApi";
export * from "./billing/billingApi";
export * from "./engineers/engineersApi";
export * from "./files/oneDrive";
export * from "./charges/chargesApi";
export * from "./finances/financesApi";
export * from "./whatsapp/whatsappApi";
export * from "./templateChecklist/templateChecklistApi";
export * from "./comments/projectCommentsApi";
export * from "./dashboard/dashboardApi";
export * from "./documents/projectDocumentsApi";
export * from "./admin/documentTypesApi";
export * from "./admin/adminBackupApi";
export * from "./solar/solarApi";
export {
  listProjectRequestIntake,
  getProjectRequestIntake,
  updateProjectRequestChecklistItem,
  createProjectRequestChecklistItem,
  updateProjectRequestChecklistItemContent,
  deleteProjectRequestChecklistItem,
  replaceProjectRequestChecklist,
  convertProjectRequest,
  saveProjectRequestDraft,
  requestProjectRequestComplement,
  updateProjectRequestStatus,
  reviewProjectRequestAttachment,
  updateProjectRequestAttachmentCategory,
  getProjectRequestIntakeAttachmentFile,
  uploadProjectRequestIntakeAttachments,
  markProjectRequestPowerOfAttorneyPrepared,
} from "./projectRequests/projectRequestsApi";
